enum ActionTypes {
  SHOW_CAM_AND_MIC_POPOVER = "SHOW_CAM_AND_MIC_POPOVER",
}

export default ActionTypes;
